/**
 * CueRail — centralized copy strings (AOF 25, i18n posture).
 */

export const cueRailCopy = {
  emptyLabel: "no cues",
  playheadLabel: "playhead",
  cueAriaPrefix: "cue",
  rulerLabel: "cue rail",
} as const;
